export default {
    CAR: 'car',
    CAR_ZERO_EMISSION: 'car-electric',
    CAR_NO_INSURANCE: 'car-no-insurance',
    MC: 'mc',
    ATV: 'atv',
    SNOWMOBILE: 'snowmobile',
    CAMPING_CAR: 'camping',
    CARAVAN: 'caravan',
    BOAT: 'boat',
};
